<template>
  <with-invoice :invoice-id="invoiceId">
    <template slot="default" slot-scope="{invoice}">
      <div v-if="invoice.status === 'Draft'">
        <attach-logs-to-invoice-form :invoice-id="invoiceId"
                                     :affected-services="affectedServices"
                                     :log="log"/>
        <detach-logs-to-invoice-form :invoice-id="invoiceId"
                                     :affected-services="affectedServices"
                                     :log="log"/>
      </div>
      <div v-else>
        <!-- empty -->
      </div>
    </template>
  </with-invoice>
</template>

<script>
  import AttachLogsToInvoiceForm from "./AttachLogsToInvoiceForm";
  import DetachLogsToInvoiceForm from "./DetachLogsToInvoiceForm";
  import WithInvoice from "./WithInvoice";

  export default {
    name: 'invoice-case-operations',
    components: {
      WithInvoice,
      AttachLogsToInvoiceForm,
      DetachLogsToInvoiceForm
    },
    props: {
      invoiceId: {
        type: Number,
        required: true
      },
      affectedServices: {
        type: Object,
        required: true
      },
      log: {
        type: Array,
        required: true
      }
    },
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/invoices/CaseInvoiceOperations.vue